import type { AbsoluteDateRange, DateRange } from './DateRangeFilterType';
import { DATE_RANGE_TYPE } from './DateRangeFilterType';

function formatAbsoluteLabel(dateRange: AbsoluteDateRange): string {
  const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
  const from = dateTimeFormat.format(dateRange.from);
  const to = dateTimeFormat.format(dateRange.to);
  return `${from} - ${to}`;
}

export const ALL_DATES_LABEL = 'All dates';

export function getDateRangeLabel(
  dateRange?: DateRange,
  optionalAllDatesLabel?: string,
): string | undefined {
  if (!dateRange) {
    return undefined;
  }
  const dateRangeType = dateRange.type;
  switch (dateRange.type) {
    case DATE_RANGE_TYPE.RELATIVE:
      return `Last ${dateRange.amount} ${dateRange.unit}`;
    case DATE_RANGE_TYPE.ABSOLUTE:
      return formatAbsoluteLabel(dateRange);
    case DATE_RANGE_TYPE.ALL:
      return optionalAllDatesLabel ?? ALL_DATES_LABEL;
    default:
      throw new Error(`Unknown DateRange type: ${dateRangeType}`);
  }
}
